import "./App.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import "boxicons/css/boxicons.min.css";

import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";

import MyProvider from "./ContextApi/MyProvider";
import { useMyContext } from "./ContextApi/MyContext";  // ← make sure path is correct

// Components
import Home from "./components/Home";
import Navbar from "./components/Navbar";
import UserNavbar from "./components/UserNavbar";   // ← important: we import it here
import Footer from "./components/Footer";
import Scrolltop from "./Scrolltop";
import Topbar from "./components/Topbar";
import SeoTags from "./components/SeoTags";
import ScrollUp from "./components/ScrollUp";
import SnapRoutes from "./components/SnapRoutes";
import PrivacyPolicy from "./components/PrivacyPolicy";
import CapoBrainPrivacyPolicy from "./components/CapoBrainPrivacyPolicy";
// Pages & Features
import About from "./components/About";
import Contact from "./components/Contact";
import Services from "./components/Services";
import Products from "./components/Products";
import Team from "./components/Team";
import Portfolio from "./components/Portfolio";
import Industries from "./components/Industries";
import Help from "./components/Help";
import Blog from "./components/Blog";
import Blogcat from "./components/Blogcat";
import DetailFAQ from "./components/DetailFAQ";
import UserLogin from "./components/UserLogin";
import Signup from "./components/Signup";
import AdminLogin from "./components/AdminLogin";
import UserProfile from "./components/UserProfile";
import TicketGenerate from "./components/TicketGenerate";
import GeneratedTickets from "./components/GeneratedTickets";
import SolvedTickets from "./components/SolvedTickets";
import PendingTicket from "./components/PendingTicket";

// Services
import Mobileappdevelopmentservices from "./components/Mobile-app-development-services";
import Webdevelopmentservices from "./components/Web-development-services";
import Softwaredevelopmentservices from "./components/Software-development-services";
import Digitalmarketingservices from "./components/Digital-marketing-services";
import SEOservices from "./components/SEO-services";
import Graphicsdesigningservices from "./components/Graphics-designing-services";

// Products
import Educationmanagementsystem from "./components/Education-management-system";
import Ecommercesolutions from "./components/Ecommerce-solutions";
import Enterpriseresourceplanning from "./components/Enterprise-resource-planning";
import Pointofsale from "./components/Point-of-sale";

// Portfolios
import WebsitePortfolio from "./components/WebsitePortfolio";
import SoftwarePortfolio from "./components/SoftwarePortfolio";
import AppPortfolio from "./components/AppPortfolio";
import AppDetail from "./components/AppDetail";

// Admin & Blog
import Admin from "./components/Admin";
import Blogcategory from "./components/Blogcategory";
import Allposts from "./components/Allposts";
import Addcategory from "./components/Addcategory";
import Allcategory from "./components/Allcategory";
import Board from "./components/Board";
import AllTickets from "./components/AllTickets";

// ────────────────────────────────
// Separate component to use hooks
// ────────────────────────────────
function AppContent() {
  const location = useLocation();
  // const { user } = useMyContext();  // ← you can use this too if you want to hide navbar when not logged in

  // Check if current page is inside user dashboard
  const isUserDashboard = location.pathname.startsWith("/user-profile");

  return (
    <>
      <Topbar />

      {/* Show ONLY one navbar */}
      {isUserDashboard ? <UserNavbar /> : <Navbar />}

      <Scrolltop />
      <SeoTags />
      <ScrollUp />

      {process.env.REACT_APP_SNAP === "true" && <SnapRoutes />}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/app/:appName" element={<AppDetail />} />

        <Route path="/about" element={<About />} />
        <Route path="/software-portfolio" element={<SoftwarePortfolio />} />
        <Route path="/app-portfolio" element={<AppPortfolio />} />
        <Route path="/products" element={<Products />} />
        <Route path="/website-portfolio" element={<WebsitePortfolio />} />
        <Route path="/faq-page" element={<DetailFAQ />} />
        <Route path="/industries" element={<Industries />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/capobrain-privacy-policy" element={<CapoBrainPrivacyPolicy />} />
        <Route path="/adminLogin" element={<AdminLogin />} />
        <Route path="/help" element={<Help />} />
        <Route path="/user-login" element={<UserLogin />} />
        <Route path="/signup" element={<Signup />} />

        {/* User protected routes */}
        <Route path="/user-profile" element={<UserProfile />}>
          <Route index element={<Navigate to="ticket-generate" replace />} />
          <Route path="ticket-generate" element={<TicketGenerate />} />
          <Route path="generated-tickets" element={<GeneratedTickets />} />
          <Route path="open-status-tickets" element={<SolvedTickets />} />
          <Route path="close-status-tickets" element={<PendingTicket />} />
        </Route>

        {/* Services */}
        <Route path="/services" element={<Services />} />
        <Route path="/web-development-services" element={<Webdevelopmentservices />} />
        <Route path="/software-development-services" element={<Softwaredevelopmentservices />} />
        <Route path="/mobile-app-development-services" element={<Mobileappdevelopmentservices />} />
        <Route path="/digital-marketing-services" element={<Digitalmarketingservices />} />
        <Route path="/seo-services" element={<SEOservices />} />
        <Route path="/graphics-designing-services" element={<Graphicsdesigningservices />} />

        {/* Products */}
        <Route path="/school-management-system" element={<Educationmanagementsystem />} />
        <Route path="/business-management-solutions" element={<Enterpriseresourceplanning />} />
        <Route path="/ecommerce-solutions" element={<Ecommercesolutions />} />
        <Route path="/restuarent-management-system" element={<Pointofsale />} />

        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/team" element={<Team />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:postSlug" element={<Blogcat />} />

        {/* Admin panel */}
        <Route path="/adminPanel" element={<Admin />}>
          <Route index element={<Navigate to="addblog" replace />} />
          <Route path="addblog" element={<Blogcategory />} />
          <Route path="allposts" element={<Allposts />} />
          <Route path="addcategory" element={<Addcategory />} />
          <Route path="allcategory" element={<Allcategory />} />
          <Route path="board" element={<Board />} />
          <Route path="alltickets" element={<AllTickets />} />
        </Route>
      </Routes>

      <Footer />
    </>
  );
}

// ────────────────────────────────
// Main App component
// ────────────────────────────────
function App() {
  return (
    <div className="App">
      <Router>
        <MyProvider>
          <AppContent />
        </MyProvider>
      </Router>
    </div>
  );
}

export default App;